import { render, staticRenderFns } from "./adjustPriceDialog.vue?vue&type=template&id=6f874640&scoped=true"
import script from "./adjustPriceDialog.vue?vue&type=script&lang=js"
export * from "./adjustPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./adjustPriceDialog.vue?vue&type=style&index=0&id=6f874640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f874640",
  null
  
)

export default component.exports